import { useContext, useMemo } from 'react';

import { AuthContext } from '@arrived/auth';

export const useMaskedEmail = () => {
  const { user } = useContext(AuthContext);

  const maskedEmail = useMemo(
    () => (user?.email ? user.email.replace(/^(.{2})[^@]+/, '$1****') : undefined),
    [user?.email]
  );

  return maskedEmail;
};
